import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://lwsumit.herokuapp.com/",
});
export default axiosInstance;
